module.exports = __webpack_public_path__ + "img/Yellow-L-3@2x.2bc3a961.png";